import { makeAutoObservable, runInAction } from 'mobx'

import type { ParentNoticeRes } from '~/@common/api/parentApi'
import { parentApi } from '~/@common/api/parentApi'

// 학부모 공지 목록 서비스
export class ParentNoticeService {
  private _notices: ParentNoticeRes[] | undefined = undefined
  private _isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  // undefined → 아직 로드 안 됨, [] → 로드 완료 & 빈 목록
  get notices() {
    return this._notices?.filter((n) => n.marked) ?? []
  }

  get isLoading() {
    return this._isLoading
  }

  get isEmpty() {
    return this._notices !== undefined && this.notices.length === 0
  }

  // 상세 페이지에서 ID로 단건 조회 (상세 api 없음)
  findById(id: number): ParentNoticeRes | undefined {
    return this._notices?.find((n) => n.id === id)
  }

  async fetchNotices() {
    this._isLoading = true

    try {
      const data = await parentApi.getNotices()
      runInAction(() => {
        this._notices = data
      })
    } catch (error) {
      // 실패해도 _notices 가 undefined 로 남으면 isEmpty 가 false 라 로딩 UI 가 안 풀린다.
      // 빈 배열로 마무리해 "빈 목록" 상태로 진입시키고 에러는 그대로 throw.
      runInAction(() => {
        this._notices = []
      })
      throw error
    } finally {
      runInAction(() => {
        this._isLoading = false
      })
    }
  }
}
